import { css } from '@emotion/react';

type TButtonBackground = 'blue' | 'orange';

const button = (background: TButtonBackground = 'orange') => css`
  width: 100%;
  max-width: 25rem;
  appearance: none;
  display: inline-block;
  padding: 0.75rem 3.5rem;
  border-radius: 0.5rem;
  border: 0;
  line-height: 1;
  font-size: 1.1rem;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  background: var(--${background});
  text-decoration: none;
  color: white;
  transition: ease-in 0.15s background;
  cursor: pointer;

  :visited {
    color: white;
  }

  :hover {
    background: var(--${background}--hover);
  }
`;

export { button };
